<template>

  <div class="vue-component-holder" v-if="renderForm">

    <div class="row">

      <div
        v-for="(field, index) in innerFields"
        v-bind:class="{'col-md-6': field.fieldType === types.datepicker, 'col-xl-12': field.fieldType !== types.datepicker}"
        class="form-element"
        v-bind:data-number="index"
      >

        <!-- Generovani elementu formulare -->
        <input-box
          v-if="field.fieldType === types.inputbox && field.dataType !== types.dataType.text && field.entityType !== 37"
          :element="field"
          :def="def"
          :updateDataRequest="updateDataRequest"
          :formDataChanged="formDataChanged"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <password
          v-if="field.fieldType === types.password"
          :element="field"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <text-area
          v-if="field.fieldType === types.inputbox && field.dataType === types.dataType.text"
          :element="field"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <auto-complete
          v-if="field.fieldType === types.autocomplete || field.fieldType === types.autocompleteSpec"
          :element="field"
          :def="def"
          :ownValue="field.fieldType === types.autocompleteSpec"
          :updateDataRequest="updateDataRequest"
          :formDataChanged="formDataChanged"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <multiselect
          v-if="field.fieldType === types.inputbox && field.entityType === 37"
          :element="field"
          :def="def"
          :ownValue="field.fieldType === types.autocompleteSpec"
          :updateDataRequest="updateDataRequest"
          :formDataChanged="formDataChanged"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <drop-down
          v-if="field.fieldType === types.dropDown"
          :element="field"
          :updateDataRequest="updateDataRequest"
          :formDataChanged="formDataChanged"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <time-picker
          v-if="field.fieldType === types.datepicker && field.dataType === types.dataType.time"
          :element="field"
          :def="def"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <date-picker
          v-if="field.fieldType === types.datepicker && field.dataType === 'DATE'"
          :element="field"
          :def="def"
          :updateDataRequest="updateDataRequest"
          :formDataChanged="formDataChanged"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <date-time-picker
          v-if="field.fieldType === types.datepicker && (field.dataType === 'DATETIME' || field.dataType === 'DATETIMEINPUT')"
          :element="field"
          :def="def"
          :updateDataRequest="updateDataRequest"
          :formDataChanged="formDataChanged"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <file-upload
          v-if="field.fieldType === types.document"
          :element="field"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <signature
          v-if="field.fieldType === types.signature"
          :element="field"
          :defaults="propsDefaults"
          @changeValue="_elementValueChange"
          @blur="_blur"
          ref="element"
        />

        <checkbox
          v-if="field.fieldType === types.checkbox"
          :element="field"
          :defaults="propsDefaults"
          @changeValue="_elementValueChange"
          ref="element"
        />

        <toggle
          v-if="field.fieldType === types.toggle"
          :element="field"
          :defaults="propsDefaults"
          @changeValue="_elementValueChange"
          ref="element"
        />


        <!-- Generovani 'Accordions' -->
        <div
          v-if="field.fieldType === types.bookMark"
          class="panel-group panel-group-continuous"
          v-bind:id="field.field"
          aria-multiselectable="true"
          role="tablist"
          ref="element"
        >
          <div class="panel panel-bookmark">
            <div class="panel-heading" v-bind:id="field.field + '-heading'" role="tab">
             <!-- <a class="panel-title" v-bind:data-parent="'#' + field.field" data-toggle="collapse" @click="activeTab = (activeTab === field.field ? null : field.field)" -->
              <a class="panel-title" v-bind:data-parent="'#' + field.field" data-toggle="collapse"
                 v-bind:href="'#' + field.field + '-holder'" v-bind:aria-controls="field.field + '-holder'"
                 aria-expanded="false">
                {{ t(field.label) }}
              </a>
            <!--  <div class="ml-15 mb-15" v-if="field.headers && defaults && field.headers.length > 1">
                <div v-for="(headerCode, index) in field.headers" :key="field.code + '-header-' + index">
                  <span>{{ defaults[headerCode] }}</span>
                </div>
              </div>
              -->
            </div>
            <div class="panel-collapse collapse" v-bind:id="field.field + '-holder'"
                 v-bind:aria-labelledby="field.field + '-heading'"
                 role="tabpanel">
              <div class="panel-body">
                <div class="row">

                  <form-generator
                    v-if="field.fields"
                    :fields="field.fields"
                    @changeValue="_elementValueChange"
                    @setValue="setValue"
                    @callBusinessRules="_blur"
                    @pushElementLinks="_pushElementLinks"
                    :def="def"
                    :propsDefaults="propsDefaults"
                    :propsIsReadOnly="propsIsReadOnly"
                    :disableRecursiveInitValues="true"
                    :callBusinessRules="false"
                    ref="subForm"
                  />

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import InputBox             from './elements/InputBox'
import Password             from './elements/Password'
import TextArea             from './elements/TextArea'
import AutoComplete         from './elements/AutoComplete'
import Multiselect          from './elements/Multiselect'
import DropDown             from './elements/DropDown'
import DatePicker           from './elements/DatePicker'
import DateTimePicker       from './elements/DateTimePicker'
import TimePicker           from './elements/TimePicker'
import FileUpload           from './elements/FileUpload'
import Signature            from './elements/Signature'
import FormValuesCollection from './../../model/collection/FormValuesCollection'
import FormElementTypes     from './../../model/FormElementTypes'
import ValueTypeConverter   from './../../model/converter/ValueTypeConverter'
import SourceLoader         from '../../model/loader/source-loader'
import Checkbox             from './elements/Checkbox'
import Toggle               from './elements/Toggle'

export default {
  name: 'form-generator',

  components: {
    Checkbox,
    Toggle,
    InputBox,
    Password,
    AutoComplete,
    Multiselect,
    DropDown,
    TextArea,
    DatePicker,
    DateTimePicker,
    TimePicker,
    FileUpload,
    Signature
  },

  props: {
    def:                        {
      type:    Object,
      default: () => {
        return {}
      }
    },
    fields:                     {
      type:    Array,
      default: () => {
        return []
      }
    },
    propsDefaults:              {
      type:    Object,
      default: () => {
        return null
      }
    },
    disableRecursiveInitValues: {
      type:    Boolean,
      default: false
    },
    callBusinessRules:          {
      type:    Boolean,
      default: true
    },
    propsIsReadOnly:            {
      type:    String,
      default: 'disable'
    },
    updateDataRequest:          {
      type:    Function,
      default: null
    },
    formDataChanged:            {
      type:    Function,
      default: null
    },
    firstLevel:                 {
      type:    Boolean,
      default: false
    }
  },

  data () {
    return {
      id:                  undefined,
      renderForm:          false,
      autocompleteLimit:   15,
      innerFields:         [],
      innerValues:         new FormValuesCollection(),
      innerOriginalValues: new FormValuesCollection(),
      activeTab:           null,
      defaults:            null,
      types:               FormElementTypes,
      typesArray:          FormElementTypes.asArray,
      elementLinks:        [],
      idtEntity:           this.$route.params.idStructure,

      preprocessDefaultsCallback: () => {
        if (this.callBusinessRules) {
          this.$emit('callBusinessRules')
        }

        this.preprocessDefaultsCallback = null
      }
    }
  },

  created () {
    this._prepareInnerFields()
  },

  mounted () {
    if (this.firstLevel) {
      setTimeout(() => {
        for (let i = 0; i < 5; i++) {
          const element = this.$refs.element[i]

          if (!element) {
            break
          }

          if (element.element && !element.element.readonly && element.element.dataType !== 'DATETIME') {
            const input = $(element.$el)
              .find('input:not([disabled="disabled"]):not(.tt-hint),select:not([tabindex="-98"]),textarea')
            input.focus()
            break
          }
        }
      }, 200)
    }
  },

  async updated () {
    await this._processDefaults()

    // spusti volani callrec v pripade ze s generuje formular pro novy zaznam -> v pripade editace se callrec
    // pri otevreni editoru nevola!!
    if (this.preprocessDefaultsCallback && this.propsDefaults && !this.propsDefaults.hasOwnProperty('ID')) {
      this.preprocessDefaultsCallback()
    }
  },

  watch: {
    'fields' () {
      this.innerFields = []

      this._prepareInnerFields()
    }
  },

  methods: {

    /**
     *
     * @param data
     */
    setDefaults (data) {
      this.defaults = data
    },

    /**
     *
     * @param values
     */
    setValues (values) {
      let data = {}

      if (!values.length) {
        for (let i = 0; i < this.innerFields.length; i++) {
          data[this.innerFields[i].name] = null
        }
      }

      this.setDefaults(data)
    },

    /**
     *
     * @param fieldName
     * @param values    {value: ...., stValue: ....}
     * @param original
     * @param select
     */
    setValue (fieldName, values, original = false, select = false) {
      if (typeof values !== 'object') {
        console.error('fuck! value must be Object!')
        return
      }

      let returnElement = undefined

      for (let i = 0; i < this.innerFields.length; i++) {
        let innerFiled = this.innerFields[i],
            element    = this.$refs.element[i],
            source     = original ? this.innerOriginalValues : this.innerValues

        if (element && typeof element.updateHighlighters === 'function') {
          element.updateHighlighters(values, fieldName)
        }

        if (!element || typeof element.updateValue !== 'function' || innerFiled.field !== fieldName) {
          source.setValue(fieldName, values.value)

          continue
        }

        element.updateValue(values)

        if (!returnElement) {
          returnElement = element
        }

        this.$emit('changeValue', { element: innerFiled, value: values.value })
        source.setValue(fieldName, values.value, innerFiled.dataType)

        if (select) {
          element.select()
        }
      }

      // jestlize nejsou dostupne zadne subformulare -> nepokracuj ve zpracovani nastaveni hodnot v subformulari
      if (!this.$refs.subForm) {
        return returnElement
      }

      // rekurzivni nastaveni v sub formulari
      for (let i = 0; i < this.$refs.subForm.length; i++) {
        let subForm = this.$refs.subForm[i]

        subForm.setValue(fieldName, values)
      }

      return returnElement
    },

    /**
     *
     * Spusti event submit na formularu a preda mu data formulare
     */
    submit () {
      let formData = this._prepareSubmitData()

      // console.log(formData)
      // return

      this.$emit('submit', { ID: this.id, data: formData })
    },

    /**
     *
     * @return FormValuesCollection
     */
    getValues () {
      return this.innerValues
    },

    /**
     *
     * @return []
     *
     */
    getPreparedValues () {
      return this._prepareSubmitData()
    },

    /**
     *
     * @return FormValuesCollection
     */
    getOriginalValues () {
      return this.innerOriginalValues
    },

    setOriginalValues (originalValues) {
      this.innerOriginalValues = originalValues
    },

    /**
     *
     * @param elementLink
     */
    checkSubFormLinkedElements (elementLink) {
      for (let i = 0; i < this.innerFields.length; i++) {
        let field = this.innerFields[i]

        if (field.field === elementLink.slave) {
          let data = {}

          data[elementLink.master] = elementLink.value

          let parseConditionData = this._parseWhereCondition('idtCustomer=%idtCustomer%', data)
          field.source.where     = parseConditionData.where
        }
      }
    },

    /**
     *
     * Vytvori interni reprezentaci elementu formulare
     * + nastavi elementum s polozkami (dropdown, autocomplete, ..) jejich prvky (stahne z api)
     * + sestavi interni reprezentaci ve spravnem poradi -> ceka na dokonceni vsech requestu
     */
    _prepareInnerFields () {
      let requests = [],
          fields   = []

      for (let i = 0; i < this.fields.length; i++) {
        let field = this.fields[i]

        if (this.typesArray.indexOf(field.FieldType) === -1) {
          continue
        }

        let innerField = this._prepareFieldData(i, field)

        if (innerField.fieldType === 'enuFormMenu') {
          continue
        }

        if (innerField.source.source) {
          innerField.source.defaults = this.propsDefaults ? this.propsDefaults : {}

          innerField.items = []
        }

        if (field.FieldType === this.types.dropDown) {
          innerField.source.limit = 9999
          innerField.source.def   = this.def
          innerField.value        = this.propsDefaults ? this.propsDefaults[innerField.field] : null
          let successCallback     = (items) => {
                innerField.items = items
              },
              errorCallback       = (error) => {
                this.handleApiError(error)
              }
            ,
              request             = SourceLoader.load(innerField.source, successCallback, errorCallback)

          requests.push(request)
        }

        fields.push(innerField)
      }

      // cekame na zpracovani vsech requestu -> potom vytvorime this.innerFields pole elementu formulare
      // ve spravnem poradi + povolime vykresleni celeho formulare
      Promise.all(requests).then(async () => {
        await this._completeInnerFields(fields)

        this.renderForm = true
      }).catch((arg) => {
        for (let i = 0; i < arg.length; i++) {
          this.handleApiError(arg[i])
        }
      })
    },

    /**
     * konvertuje data z json popisujici formular do interniho ('vychoziho') stavu popisujiciho formular
     * @private
     */
    _prepareFieldData (index, apiFieldData) {
      let field = {
        code:       apiFieldData.Code,
        index:      index,
        field:      apiFieldData.Field,
        name:       apiFieldData.Field,
        fieldView:  null,
        label:      apiFieldData.Label,
        dataType:   apiFieldData.DataType,
        fieldType:  apiFieldData.FieldType,
        entityType: apiFieldData.EntityType,
        readonly:   apiFieldData.IsReadOnly === 'true',
        source:     {},
        document:   {},
        items:      [],
        fields:     [],
        icons:      [],
        layout:     null,
        headers:     null,
        calrec:     undefined
      }

      if (apiFieldData.hasOwnProperty('CalRec')) {
        field.calrec = apiFieldData.CalRec
      }

      if (apiFieldData.hasOwnProperty('FieldViewed')) {
        field.fieldView = apiFieldData.FieldViewed
      }

      if (apiFieldData.hasOwnProperty('Layout')) {
        const layoutSplit = apiFieldData.Layout.split(';')
        field.layout = layoutSplit.length === 1 ? layoutSplit[0] : layoutSplit
      }

      if (apiFieldData.hasOwnProperty('Headers')) {
        field.headers = apiFieldData.Headers.split(',')
      }

      if (apiFieldData.hasOwnProperty('Items')) {
        field.items = apiFieldData.Items
      }

      if (field.fieldType === this.types.autocompleteSpec
        || field.fieldType === this.types.autocomplete
        || field.fieldType === this.types.dropDown
        || field.fieldType === this.types.inputbox && field.entityType === 37
      ) {
        let limit = undefined,
            label = apiFieldData.hasOwnProperty('FieldViewed') ? apiFieldData.FieldViewed : apiFieldData.ColumnName

        if (field.fieldType === this.types.autocomplete
          || field.fieldType === this.types.autocompleteSpec
          || field.fieldType === this.types.inputbox && field.entityType === 37
        ) {
          limit = this.autocompleteLimit
        }

        field.source = {
          source:                 apiFieldData.ViewName,
          value:                  apiFieldData.ColumnName,
          label:                  label,
          limit:                  limit,
          idtEntity:              apiFieldData.idtEntity,
          idtEntityStructureFrom: apiFieldData.idtEntityStructureFrom,
          columnName:             apiFieldData.ColumnName,
          defaultValue:           this.propsDefaults ? this.propsDefaults[label] : null
        }

        if (apiFieldData.hasOwnProperty('Source.Condition')) {
          field.source.condition = apiFieldData['Source.Condition']
        }

        if (apiFieldData.hasOwnProperty('WhereCondition')) {
          let parseconditionData = this._parseWhereCondition(apiFieldData.WhereCondition, this.propsDefaults ? this.propsDefaults : {})
          field.source.where     = parseconditionData.where

          this._pushElementLinks({ master: parseconditionData.key, slave: field.field, index: index })
        }

      }

      if (apiFieldData.hasOwnProperty('Document.Field.Content')) {
        field.document = {
          dataKey:      apiFieldData['Document.Field.Content'],
          dataFileName: apiFieldData['Document.Field.FileName'],
          dataFileGUID: apiFieldData['Document.Field.FileGUID']
        }
      }

      if (apiFieldData.hasOwnProperty('Fields') && apiFieldData.Fields.length) {
        apiFieldData.Fields.forEach((item) => {
          if (item.FieldType === this.types.icon) {
            let iconValue = {}
            if (this.propsDefaults && this.propsDefaults.hasOwnProperty(item.ColumnName)) {
              iconValue = JSON.parse(this.propsDefaults[item.ColumnName])
            }
            field.icons.push({ def: item, value: iconValue })
          }
          else {
            field.fields.push(item)
          }
        })
      }

      if (this.propsIsReadOnly === 'true') {
        field.readonly = true
      }

      return field
    },

    /**
     *
     * @param fields
     * @private
     */
    _completeInnerFields (fields) {
      this.innerValues         = new FormValuesCollection()
      this.innerOriginalValues = new FormValuesCollection()

      for (let i = 0; i < this.fields.length; i++) {
        let apiField = this.fields[i]

        for (let x = 0; x < fields.length; x++) {
          let field = fields[x]

          if (apiField.Field === field.field) {

            // nastaveni interni reprezentace hodnot formulare
            this
              .innerValues
              .push({
                key:   field.name,
                value: null,
                type:  field.dataType
              })

            this
              .innerOriginalValues
              .push({
                key:   field.name,
                value: null,
                type:  field.dataType
              })

            // pridani elementu do interni reprezentace struktury formulare
            this
              .innerFields
              .push(field)
          }

        }
      }
    },

    /**
     *
     * @private
     */
    _elementValueChange (args) {
      if (args.hasOwnProperty('data')) {
        for (const key of Object.keys(args.data)) {
          this.innerValues.setValue(key, args.data[key], args.element.dataType)
        }
      }
      else {
        this.innerValues.setValue(args.element.name, args.value, args.element.dataType)
      }

      if (args.hasOwnProperty('stValue')) {
        this.innerValues.setValue('ST' + args.element.name, args.stValue, args.element.dataType)
      }

      // kontrola jestli ma zmeneny element nejake zavislosti na jine elementy, pokud ano zkontroluj je a nastav patricne hodnoty
      // 'podrizenym' elementum
      for (let i = 0; i < this.elementLinks.length; i++) {
        let elementLink = this.elementLinks[i]

        if (args.element.field === elementLink.master) {
          elementLink['value'] = args.value

          // nastaveni where podminky + zmena vychozich polozek u autocomplete + dropdownu
          this.checkSubFormLinkedElements(elementLink)

          // aplikace
          if (!this.$refs.subForm) {
            continue
          }
          for (let i = 0; i < this.$refs.subForm.length; i++) {
            this.$refs.subForm[i].checkSubFormLinkedElements(elementLink)
          }
        }
      }

      // proiterovani subformularu (formGeneratoru) -> aktualizace innerDefaults vnorenych instanci
      if (!this.$refs.subForm) {
        this.$emit('changeValue', args)

        return
      }

      for (let subForm of this.$refs.subForm) {

        if (args.hasOwnProperty('data')) {
          for (const key of Object.keys(args.data)) {
            subForm.innerValues.setValue(key, args.data[key], args.element.dataType)
          }
        }
        else {
          subForm.innerValues.setValue(args.element.name, args.value, args.element.dataType)
        }

        if (args.hasOwnProperty('stValue')) {
          subForm.innerValues.setValue('ST' + args.element.name, args.stValue, args.element.dataType)
        }
      }

      this.$emit('changeValue', args)
    },

    /**
     *
     * @private
     */
    _blur (args) {

      // volani obchodnich pravidel
      this.$emit('callBusinessRules', args)
    },

    /**
     *
     * @private
     */
    _prepareSubmitData () {
      let values    = this.innerValues.getValues(),
          output    = {},
          processed = []

      for (let i = 0; i < values.length; i++) {
        let _innerItem = values[i],
            value      = _innerItem.value,
            key        = _innerItem.key

        if (processed.indexOf(key) !== -1) {
          continue
        }

        value = ValueTypeConverter.convert(_innerItem, _innerItem.value)

        if (value && typeof value === 'object') {
          Object
            .keys(value)
            .map(key => {
              processed.push(key)
              output[key] = value[key]
            })

          continue
        }

        output[key] = value
      }

      return output
    },

    /**
     * Nastaveni vychozich hodnot elementu formulare
     */
    _processDefaults () {
      this.innerValues         = new FormValuesCollection()
      this.innerOriginalValues = new FormValuesCollection()

      if (this.propsDefaults) {
        this.defaults = this.propsDefaults
      }

      if (!this.defaults) {
        return
      }

      this.id = this.defaults.ID

      let processed = []

      Object
        .keys(this.defaults)
        .map(key => {
          let dataType = this._getDataType(key)

          // @TODO: vyresit lepe! optimalizovat metodu _getDataType
          // v pripade, ze se jedna vytvarnei noveho zaznamu -> nastavuj hodnoty i bez dataTypu
          if (!this.defaults.ID) {
            this.innerValues.setValue(key, this.defaults[key], dataType)
            this.innerOriginalValues.setValue(key, this.defaults[key], dataType)

            return
          }

          if (processed.indexOf(key) > -1) {
            return
          }

          // if (dataType) {
          this.innerValues.setValue(key, this.defaults[key], dataType)
          this.innerOriginalValues.setValue(key, this.defaults[key], dataType)

          processed.push(key)
          // }
        })

      this._setElementsValue()
    },

    /**
     *
     * @private
     */
    _getDataType (field) {
      return this._getDataTypeInner(field, this.innerFields)
    },

    /**
     *
     * @private
     */
    _getDataTypeInner (fieldName, fields, depth = 0) {
      for (let i = 0; i < fields.length; i++) {
        let innerFiled = fields[i]

        if (innerFiled.fields && innerFiled.fields.length && !this.disableRecursiveInitValues) {
          depth++
          let result = this._getDataTypeInner(fieldName, innerFiled.fields, depth)
          if (result) {
            return result
          }
        }

        let fieldKey      = 'field',
            dataType      = 'dataType',
            fieldKeyUpper = 'Field',
            dataTypeUpper = 'DataType',
            key           = undefined,
            type          = undefined

        if (innerFiled[fieldKey]) {
          key  = innerFiled[fieldKey]
          type = innerFiled[dataType]
        }

        if (!key && innerFiled[fieldKeyUpper]) {
          key  = innerFiled[fieldKeyUpper]
          type = innerFiled[dataTypeUpper]
        }

        if (key && key === fieldName) {
          return type
        }
      }
    },

    /**
     *
     * @private
     */
    _setElementsValue () {
      if (!this.$refs.element) {
        return
      }

      for (let i = 0; i < this.innerFields.length; i++) {
        let innerFiled = this.innerFields[i],
            element    = this.$refs.element[i]

        if (element && typeof element.updateValue === 'function') {
          let value   = this.innerValues.getValue(innerFiled.name),
              stValue = this.innerValues.getValue('ST' + innerFiled.name),
              values  = {
                value:   value,
                stValue: stValue ? stValue : value
              }

          element.updateValue(values)
        }
      }

      this.$emit('elementsValueSetup')
    },

    /**
     *
     * @param stringWhereCondition
     * @param values
     * @return {*}
     * @private
     */
    _parseWhereCondition (stringWhereCondition, values) {
      let stringWhereConditionSplit = stringWhereCondition.split('='),
          key                       = stringWhereConditionSplit[0],
          replacement               = stringWhereConditionSplit[1],
          value                     = null

      // if (replacement.indexOf('%') === -1 && !TypeHelper.isNumeric(replacement) && replacement !== 'null') {
      //   return {where: stringWhereCondition, key: key}
      // }

      key = 'ID' + key.slice(2)  // @TODO: vyresit lepe!!!

      Object
        .keys(values)
        .map(defaultsKey => {
          if (defaultsKey === key) {
            value = values[defaultsKey]
          }
        })

      let where = ''

      if (value) {
        where = stringWhereCondition.replace(replacement, value)
      }
      else {
        if (replacement.indexOf('%') === -1) {
          where = stringWhereCondition
        }
      }

      return { where: where, key: key }
    },

    /**
     *
     * @param args
     * @private
     */
    _pushElementLinks (args) {
      this.$emit('pushElementLinks', args)
      this.elementLinks.push(args)
    },

    changeEelement (dataFilters) {
      for (const element of this.$refs.element) {
        if (!element.element || !element.element.code) {
          continue
        }

        for (const keyFilter in dataFilters) {
          if (keyFilter.includes(element.element.code.toUpperCase())) {
            if (parseInt(dataFilters[keyFilter]) === 2) {
              element.setRender(true)
            }
            if (parseInt(dataFilters[keyFilter]) === 1) {
              element.element.readonly = 'true'
            }
            if (parseInt(dataFilters[keyFilter]) === 0) {
              element.element.readonly = false
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.panel.panel-bookmark .row {
  margin: 0;
}
</style>
